var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Anmeldung",
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 84,
    viewBox: "0 0 112 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Anmeldung .cls-1 {\n        fill: #9ea1a2;\n      }\n\n      #Anmeldung .cls-2 {\n        fill: #c5d75d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-983.903 -436.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1086",
    "data-name": "Gruppe 1086",
    transform: "translate(1030.374 455.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_478",
    "data-name": "Pfad 478",
    className: "cls-1",
    d: "M1034.535,472.586a11.515,11.515,0,1,1,11.506-11.515A11.523,11.523,0,0,1,1034.535,472.586Zm0-19.853a8.338,8.338,0,1,0,8.332,8.338A8.344,8.344,0,0,0,1034.535,452.733Z",
    transform: "translate(-1011.275 -449.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_479",
    "data-name": "Pfad 479",
    className: "cls-1",
    d: "M1038.609,488.883a24.027,24.027,0,0,1-23.145-17.744l-.417-1.545,16.043-4.223.558.308a13.979,13.979,0,0,0,13.362-.028l.555-.311,16.6,4.275-.423,1.555A24.032,24.032,0,0,1,1038.609,488.883Zm-19.6-17.046a20.79,20.79,0,0,0,39.194.038l-12.215-3.146a17.192,17.192,0,0,1-15.3.034Z",
    transform: "translate(-1015.047 -442.08)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_480",
    "data-name": "Pfad 480",
    className: "cls-2",
    d: "M1043.493,436.589a42.027,42.027,0,0,0-38.783,25.967l2.269,2.271a39.056,39.056,0,1,1,.079,27.726l-2.269,2.271a41.974,41.974,0,1,0,38.7-58.235Z",
    transform: "translate(10.443 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_481",
    "data-name": "Pfad 481",
    className: "cls-2",
    d: "M1020.085,474.951l4.6-4.279-4.6-4.28v-.145h-.156l-13.9-12.932-2.893,3.108,10.56,9.824H981.9v8.842h31.806l-10.568,9.829,2.893,3.108,13.9-12.937h.148Z",
    transform: "translate(2 7.922)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth);
export default __webpack_public_path__ + "static/media/auth.4910df7cf330f6067ccb16af143a7f39.svg";
export { ForwardRef as ReactComponent };